import './redeemLocations.scss';

import { Col, Row, Typography } from 'antd';
import React, { useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import ZLSection from '../../containers/zl-section/zl-section';

import Heading, { HeadingSize } from '../../components/heading/heading';


import { actionCreators as PurchaseTypeActions, PurchaseTypes } from '../../store/PurchaseTypes';
import { actionCreators as currencyActions } from '../../store/Currencies';
import { actionCreators as SiteActions } from '../../store/Sites';
import useVenueBackedCurrencies from '../../hooks/useVenueBackedCurrencies';

import CurrencyForVoucher from '../../components/currency-for-voucher/currency-for-voucher';
import RedeemVenueList from '../../components/redeem-locations-popup/RedeemVenueList';
import { IApplicationState } from '../../store';
import { Routes, navigateTo } from '../../helpers/routes';

import { SiteChangeSource } from '../../types/SiteChangeTypes';
import useSiteChange from '../../hooks/useSiteChange';


export interface IRedeemLocationsPageProps {
}

const RedeemLocationsPage: React.FunctionComponent<IRedeemLocationsPageProps> = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const params: any = useParams();
    const location = useLocation();

    const { changeSite } = useSiteChange();

    const { currencies: availableCurrencies, isLoading: currenciesLoading, hasLoaded: currenciesLoaded, loadFailed: currenciesLoadFailed } = useVenueBackedCurrencies();

    const allSites = useSelector((state: IApplicationState) => state.sites.sites);

    useEffect(() => {
        //use effect to load the venue list data from api
        console.log(`redeem locations page running initilisation logic / useEffect`);
        dispatch(SiteActions.loadSites());
    }, [dispatch]);

    //use effect to load available global gift currency options
    useEffect(() => {
        if (!currenciesLoading && !currenciesLoaded && !currenciesLoadFailed) {
            console.log(`Global gift page triggering load of global currencies`);
            dispatch(currencyActions.loadGlobalPaymentCurrencies());
        }
    }, [dispatch, currenciesLoading, currenciesLoaded, currenciesLoadFailed]);

    const listContainerId = "redeem-location-list";
    const pageTitle = t('redeemLocationsPage.title');
    const pageDescription = t('redeemLocationsPage.subTitle');
    
    const voucherCurrency = availableCurrencies.find(x => x.code === params?.currency);


    const venueOnClick = async (venueId: number) => {
        dispatch(PurchaseTypeActions.selectPurchaseType(PurchaseTypes.Booking));

        const clickedSite = allSites.find(x => x.siteId === venueId);
        if (clickedSite) {
            //Make sure we are properly swapped onto the selected venue
            await changeSite(clickedSite, { source: SiteChangeSource.UserSelection }, false, false, true);

            //navigate to the booking flow with the clicked venue selected, and carry the gift voucher accross in the search params
            dispatch(navigateTo(Routes.BookNow, clickedSite.urlKey, location.search));
        }
    };

    return (
        <React.Fragment>
            <Row justify="start" align="top" id="redeem-locations-page">

                {/*Page heading and title*/}
                <Col xs={24} sm={24} md={24} lg={18}>
                    <ZLSection title={''} active={true} scrollTo={false}>
                        <Heading level={HeadingSize.One} >
                            {pageTitle}
                        </Heading>
                        <Typography.Paragraph style={{ fontSize: '14px' }}>
                            {pageDescription}
                        </Typography.Paragraph>

                        <CurrencyForVoucher currency={voucherCurrency} isLoaded={currenciesLoaded} />
                    </ZLSection>
                </Col>

                {/* Main page ui elements and data input*/}
                <Col xs={24} sm={24} md={24} lg={18}>
                    <ZLSection title={''} active={true} scrollTo={false}>
                        <Row id={listContainerId} >
                            {voucherCurrency && <RedeemVenueList parentContainerId={listContainerId} currencyFilter={voucherCurrency} venueOnClick={venueOnClick} />}
                        </Row>
                    </ZLSection>
                </Col>

            </Row>
        </React.Fragment>
    );
};

export default RedeemLocationsPage;
